export const sortByOptions = [
  'PRIORITY',
  'REFERENCE',
  'DEBTOR_ACCOUNT',
  'DEBTOR_NAME',
  'AMOUNT',
  'CURRENCY',
  'EXECUTION_DATE',
  'CREDITOR_ACCOUNT',
  'CREDITOR_NAME',
  'CHARGES',
  'SERVICE_LEVEL',
  'STATUS',
  'FTS_STATUS',
  'DB_STATUS',
] as const;
